export default {
  methods: {
    formatFecha(valor){
      if(valor){
        const options = { day: '2-digit', month: 'short', year: '2-digit' };
        return new Date(valor).toLocaleDateString('es-ES', options);
      }
    }
  }
}